import React from "react"
import styled, { css } from "styled-components"
import Breakpoints from "../breakpoints"
import Grid from "../grid"
import { T } from "../typography.styles"
import VariantContainer from "../../../design-system/atoms/variant-container"
import mergeVariants from "../../../design-system/util/merge-variants"

const BaseStyle = css`
  background-color: var(--tricorn-black);
  padding: 24px 0;
  text-align: center;
  @media (min-width: ${Breakpoints.md}) {
    padding: 48px 0;
    text-align: left;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 64px 0;
  }
`

const Title = styled.h2`
  ${T.sm.h2.bold}
  color: var(--light-background);
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 1 / -1;
    border-left: 4px solid var(--burnt-orange);
    padding-left: 32px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / -1;
    font-size: 36px;
  }
`

function AccentTitleDivider({ children, variants, className }) {
  return (
    <VariantContainer
      className={className}
      variants={mergeVariants([BaseStyle], variants)}
    >
      <Grid>
        <Title> {children} </Title>
      </Grid>
    </VariantContainer>
  )
}

export default AccentTitleDivider
